"use client";

import { createContext, type PropsWithChildren, useRef } from "react";
import { createStore, type TStore } from "./store";
export const StoreContext = createContext<TStore | null>(null);
export const StoreProvider = ({
  children
}: PropsWithChildren) => {
  const storeRef = useRef<TStore>(null);
  if (!storeRef.current) {
    storeRef.current = createStore();
  }
  return <StoreContext.Provider value={storeRef.current}>{children}</StoreContext.Provider>;
};